import { useContext } from 'react';

import { HistogramChartOverlayRefContext } from '../contexts/HistogramChartOverlayRefContext.js';

export const useHistogramChartOverlayRef = () => {
  const context = useContext(HistogramChartOverlayRefContext);

  if (!context) {
    throw new Error(
      '"useHistogramChartOverlayRef" needs to be used under "HistogramChartOverlayRefContext"',
    );
  }

  return context;
};
